import {Element} from "@api/models/Element";
import {ElementInterface} from "@api/models/interfaces/ElementInterface";
import {PresentationInterface} from "@api/models/interfaces/web-conference/PresentationInterface";
import {FileTypes} from "@api/enums/WebConferenceSlides/FileTypes";
import {RenderingStatus} from "@api/enums/WebConferenceSlides/RenderingStatus";

export class WebConferencesSlides extends Element implements PresentationInterface {
    userId: number;
    webConferenceId: string;
    originFileName: string;
    originFileType: FileTypes;
    originFileId: string;
    fileIds: string[];
    renderingStatus: RenderingStatus;

    constructor(data: ElementInterface) {
        super(data, 'WebConferencesSlides');
    }
}
